/**
 * Geode Voice (UPT-2000 V1a, spec web V1 §5.2) — lecture de la consommation du mois (`GET …/voice/usage`).
 *
 * UN seul appel à l'arrêt d'une session et un seul à l'ouverture de la ligne de consommation : jamais de
 * sondage. Les appels simultanés sont fusionnés ; une lecture toute récente n'est pas refaite (sauf `force`,
 * utilisé à l'arrêt pour inclure la session qui vient de se terminer).
 */
import { getVoiceUsage } from './voiceApi';
import { useVoiceStore } from './voiceStore';

/** Une lecture plus récente que ceci (millisecondes) n'est pas refaite à l'ouverture de la ligne. */
export const USAGE_FRESH_MS = 15_000;

let inFlight: Promise<void> | null = null;

export const refreshVoiceUsage = (options: { force?: boolean } = {}): Promise<void> => {
  if (inFlight) {
    return inFlight;
  }
  const store = useVoiceStore.getState();
  if (!options.force && store.usageStatus !== 'idle' && Date.now() - store.usageFetchedAt < USAGE_FRESH_MS) {
    return Promise.resolve();
  }
  store.setUsageStatus('loading');
  const run: Promise<void> = (async () => {
    try {
      const usage = await getVoiceUsage();
      useVoiceStore.getState().setUsage(usage);
    } catch {
      useVoiceStore.getState().setUsageStatus('error');
    }
  })().finally(() => {
    if (inFlight === run) {
      inFlight = null;
    }
  });
  inFlight = run;
  return run;
};

/** Pour les tests : oublie l'appel en cours. */
export const resetVoiceUsageRefresh = (): void => {
  inFlight = null;
};
